// Setas sobre a galeria do produto. No desktop com miniaturas, troca a mídia ativa;
// no celular ou layout empilhado, delega para os botões do slider.
if (!customElements.get('gallery-arrows')) {
  customElements.define(
    'gallery-arrows',
    class GalleryArrows extends HTMLElement {
      connectedCallback() {
        this.gallery = this.closest('media-gallery');
        this.viewer = this.closest('slider-component');
        this.mql = window.matchMedia('(min-width: 750px)');
        this.querySelectorAll('[data-direction]').forEach((button) => {
          button.addEventListener('click', () => this.go(button.dataset.direction));
        });
      }

      items() {
        return [...this.viewer.querySelectorAll('.product__media-item[data-media-id]')].filter(
          (item) => !item.classList.contains('product__media-item--variant') || item.classList.contains('is-active')
        );
      }

      go(direction) {
        const usesActiveMedia =
          this.gallery && this.mql.matches && (this.gallery.dataset.desktopLayout || '').includes('thumbnail');

        if (!usesActiveMedia) {
          const name = direction === 'next' ? 'next' : 'previous';
          this.viewer.querySelector(`button[name="${name}"]`)?.click();
          return;
        }

        const items = this.items();
        if (items.length < 2) return;
        const current = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
        const target = direction === 'next' ? (current + 1) % items.length : (current - 1 + items.length) % items.length;
        this.gallery.setActiveMedia(items[target].dataset.mediaId, false);
      }
    }
  );
}
